import { switchyardHref } from '#pplx/frontend/apps/ask/routing/switchyardRoutes.js';
const AUTOMATIONS_PATH = '/computer/automations';
export function isAutomationRunSessionNavigable(run) {
    return Boolean(run.contextUuid && run.isSessionReady && !run.isCollecting);
}
export function getAutomationSidebarPath(automationId) {
    return automationId
        ? `${AUTOMATIONS_PATH}?automationId=${encodeURIComponent(automationId)}`
        : `${AUTOMATIONS_PATH}?createAutomation=true`;
}
export function getAutomationSessionPath(contextUuid, entryUuid, automationId) {
    const query = automationId ? `?automationId=${encodeURIComponent(automationId)}` : '';
    const path = `/computer/tasks/${encodeURIComponent(contextUuid)}${query}`;
    return entryUuid ? `${path}#${encodeURIComponent(entryUuid)}` : path;
}
/** Teammate runs open on the Teammate page; other runs open their Computer session. */
export function getAutomationRunPath(contextUuid, { automationId, entryUuid, isTeammateOrchestrator, }) {
    return isTeammateOrchestrator
        ? switchyardHref(contextUuid)
        : getAutomationSessionPath(contextUuid, entryUuid, automationId);
}
/**
 * Opens the latest run's session once its thread exists, otherwise the
 * automation's details sheet.
 */
export function getAutomationLatestRunPath(automationId, latestRun) {
    const contextUUID = latestRun?.thread?.contextUUID ?? latestRun?.contextUUID;
    return latestRun?.thread?.entryId && contextUUID
        ? getAutomationRunPath(contextUUID, {
            isTeammateOrchestrator: latestRun.thread.isTeammateOrchestrator,
        })
        : getAutomationSidebarPath(automationId);
}
export function isAutomationRoutePath(pathname, automationId) {
    const detailPath = `${AUTOMATIONS_PATH}/${encodeURIComponent(automationId)}`;
    return pathname === detailPath || pathname?.startsWith(`${detailPath}/`) === true;
}
//# sourceMappingURL=automationRunRoute.js.map